<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line">
    <div class="ir-line--left">
      <img src="/Content/svg/client-logo.svg" class="ir-logo" />
    </div>
    <div class="ir-line--right"></div>
    <div class="ir-line-content">
      <span>{{ 'login.change-password' | translate }}</span>
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="ir-content-fixed ir-mv2 th-content">
    <form [formGroup]="changePasswordForm" novalidate (ngSubmit)="onSubmit(changePasswordForm)">
      <p class="th-txt">
        <span>{{ 'login.change-password' | translate }}</span>
      </p>
      <table class="ir-login-table">
        <tr>
          <td>
            <h2>
              <span>{{ 'login.old-password' | translate }}</span>
            </h2>
          </td>
          <td>
            <div class="ir-form-group">
              <input
                formControlName="oldPassword"
                class="ir-form-set"
                type="password"
                placeholder="{{ 'login.old-password' | translate }}"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <h2>
              <span>{{ 'login.new-password' | translate }}</span>
            </h2>
          </td>
          <td>
            <div class="ir-form-group">
              <input
                formControlName="newPassword"
                class="ir-form-set"
                type="password"
                placeholder="{{ 'login.new-password' | translate }}"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <h2>
              <span>{{ 'login.confirm-password' | translate }}</span>
            </h2>
          </td>
          <td>
            <div class="ir-form-group">
              <input
                formControlName="confirmPassword"
                class="ir-form-set"
                type="password"
                placeholder="{{ 'login.confirm-password' | translate }}"
              />
            </div>
          </td>
        </tr>
      </table>
      <div class="ir-position--b th-home">
        <div class="ir-bloc ir-ph4 ir-pv4">
          <div class="ir-row">
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4"></div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4"></div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <button class="ir-btn ir-btn--big ir-btn--block th-btn-action" type="submit">
                <span>{{ 'login.change-password' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
